import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { nonAgentGuard } from './guards/non-agent.guard';


export const routes: Routes = [
    { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
    { path: 'order',
        loadComponent: () => import('./pages/order/order.component').then(m => m.OrderComponent),
         canActivate: [authGuard]
    },
    { path: 'dashboard',
        loadComponent: () => import('./pages/orders-dashboard/orders-dashboard.component').then(m => m.OrdersDashboardComponent),
         canActivate: [authGuard, nonAgentGuard]
    },
    { path: 'online-dashboard',
        loadComponent: () => import('./pages/online-dashboard/online-dashboard.component').then(m => m.OnlineDashboardComponent),
         canActivate: [authGuard, nonAgentGuard]
    },
    { path: 'day-products',
        loadComponent: () => import('./pages/day-products/day-products.component').then(m => m.DayProductsComponent),
         canActivate: [authGuard, nonAgentGuard]
    },
    { path: 'agent-dashboard',
        loadComponent: () => import('./pages/agent-orders/agent-orders.component').then(m => m.AgentOrdersComponent),
         canActivate: [authGuard],
         data: { mode: 'today' }
    },
    { path: 'agent-upcoming-orders',
        loadComponent: () => import('./pages/agent-orders/agent-orders.component').then(m => m.AgentOrdersComponent),
         canActivate: [authGuard],
         data: { mode: 'upcoming' }
    },
    { path: 'agent-delivery-calculator',
        loadComponent: () => import('./pages/agent-delivery-calculator/agent-delivery-calculator.component').then(m => m.AgentDeliveryCalculatorComponent),
         canActivate: [authGuard]
    },
    { path: 'admin-orders',
        loadComponent: () => import('./pages/admin-orders/admin-orders.component').then(m => m.AdminOrdersComponent),
         canActivate: [authGuard, nonAgentGuard]
    },
    { path: 'shop-orders',
        loadComponent: () => import('./pages/shop-orders/shop-orders.component').then(m => m.ShopOrdersComponent),
         canActivate: [authGuard]
    },
    { path: 'stock-levels',
        loadComponent: () => import('./pages/stock-levels/stock-levels.component').then(m => m.StockLevelsComponent),
         canActivate: [authGuard]
    }
];
